export const splitString = (string, delimiter = ',') => string ? string.trim().split(delimiter).map(val => val.trim()) : [];

export const replaceArray = (string, find, replace) => {
    for (let i = 0; i < find.length; i++) {
        string = string.replaceAll(find[i], replace[i]);
    }

    return string;
};